<template>
  <div class="dataList repairData">
    <div class="p16">
      <p style="font-weight: bold;">档案报表<span class="moneys fontSize14">(今日数据将在次日0点更新)</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs br10">
            <div class="titles">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>数据汇总</i></p>
              <el-date-picker v-model="query.beginTime" type="date" value-format="yyyy-MM-dd" :picker-options="beginPickerOptions" :clearable="false" :editable="false" placeholder="开始时间" @change="timeChange" class="ml10"></el-date-picker>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">档案总数</p>
                <p class="van-label">{{amount.repairDocumentTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">实际档案总数</p>
                <p class="van-label">{{amount.repairDocumentActualTotal}}</p>
              </el-col>
              <el-col class="cols cur" :span="4">
                <div @click="skip('finish')">
                  <p class="van-text">已完成</p>
                  <p class="van-label">{{amount.repairFinishTotal}}</p>
                </div>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">已完成金额</p>
                <p class="van-label">{{amount.repairFinishAmount}}</p>
              </el-col>
              
              <el-col class="cols cur" :span="4">
                <div @click="skip('intimeFinish')">
                  <p class="van-text">期限内完成</p>
                  <p class="van-label">{{amount.repairDocumentInTimeFinishTotal}}</p>
                </div>
              </el-col>
              <el-col class="cols cur" :span="4">
                <div @click="skip('outtimeFinish')">
                  <p class="van-text">逾期完成</p>
                  <p class="van-label">{{amount.repairDocumentExpireTimeFinishTotal}}</p>
                </div>
              </el-col>
              <el-col class="cols cur" :span="4">
                <div @click="skip('outtimeUnfinish')">
                  <p class="van-text">逾期未完成</p>
                  <p class="van-label">{{amount.repairExceedTimeTotal}}</p>
                </div>
              </el-col>
              <el-col class="cols cur" :span="4">
                <div @click="skip('handle')">
                  <p class="van-text">进行中</p>
                  <p class="van-label">{{amount.repairHandleTotal}}</p>
                </div>
              </el-col>
              <el-col class="cols cur" :span="4">
                <div @click="skip('refund')">
                  <p class="van-text">退款数量</p>
                  <p class="van-label">{{amount.repairRefundTotal}}</p>
                </div>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">退款金额</p>
                <p class="van-label">{{amount.repairRefundAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">修护成功率</p>
                <p class="van-label">{{amount.rehabilitationRate}}</p>
              </el-col>
			  <el-col class="cols" :span="4">
			    <p class="van-text">年度修护成功率</p>
			    <p class="van-label">{{amount.finishRate}}</p>
			  </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";

export default {
  mixins: [minxin],
  data() {
    return {
      amount: {},
      downloadUrl: require("../../../assets/images/home/data.png"),
      amountBO: {},
      paywaySetBOList: [],
      invoiceBOList: [],
      orderItemSumBOList: [],
      query: {
        beginTime: new Date(),
        endTime: new Date()
      }
    };
  },
  computed: {
    beginPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      };
    }
  },
  components: {},
  created() {
	var today = new Date();
	today.setDate(today.getDate() - 1);
	var yesterday = today.toISOString().slice(0,10);
	this.query.beginTime=yesterday;
	this.query.endTime=yesterday;
    this.pageDetailByShop();
  },
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    timeChange (value) {
      console.log(value);
      this.query.beginTime = value;
      this.query.endTime = value;
      this.pageDetailByShop();
    },
    skip (type) {
      this.$router.push({
        path: "/collectMoney/paperRepair/edit"
      })
      this.$store.commit("setCurentPage", 'cashier');
      localStorage.setItem("setCurentUrl", '/collectMoney/paperRepair/edit');
      sessionStorage.setItem("repairStatus", type);
    },
    pageDetailByShop() {
      this.$api
        .post(this.$url.report.repairDocumentSummary, {
          beginTime: this.query.beginTime,
          endTime: this.query.endTime
        })
        .then(res => {
          this.amount = res;
        })
        .catch(error => {
          this.error = true;
        });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.repairData {
  /deep/.el-date-editor.el-input,
  /deep/ .el-date-editor.el-input__inner {
    // width: 220px;
    width: 150px;
    height: 32px;
  }
  /deep/ .el-input__inner {
    height: 32px;
  }
  /deep/.el-input__icon {
    line-height: 32px;
  }
}
</style>